import { SettingsLayout } from "./layout"
import { Section } from "./index"
import { OrgFieldsSettings } from "./org_fields"
import { EmailSummaryConfigComponent } from "@/components/email-summary-config"
import { AutoValidationSettings } from "./auto_validation"
import { LogisticsProvidersSettings } from "./logistics_providers"
import { BrandFiles } from "@/components/brand_files"
import { ProductCatalogSettings } from "./product_catalog"
import { CustomerPricingSettings } from "./customer_pricing"
import { SkuMappingUpload } from "./sku_mapping_upload"
import { PromotionUpload } from "./vividly_promotion_upload"
import { SkillsFileEditor } from "./skills_file"
import { HideAccountingFromSalesSetting } from "./hide_accounting_from_sales"
import { UserState } from "src/auth/user.tsx"
import { usePageTitle } from "@/utils"

export function SettingsOrganization() {
  usePageTitle("Organization")
  return (
    <SettingsLayout>
      <SkillsFileSection />
      <HideAccountingFromSalesSection />
      <AutoValidationSettingsSection />
      <OrgFieldsSettingsSection />
      <LogisticsProvidersSettingsSection />
      <ProductCatalogSettingsSection />
      <CustomerPricingSettingsSection />
      <PromotionImportSection />
      <SkuMappingUploadSection />
      <EmailSummaryConfigSection />
      <OrganizationFilesSection />
    </SettingsLayout>
  )
}

function SkillsFileSection() {
  return (
    <Section title="AI Knowledge Base" class="bg-white rounded-lg shadow-sm p-6">
      <SkillsFileEditor />
    </Section>
  )
}

function HideAccountingFromSalesSection() {
  const user = UserState.use()
  if (user?.role !== "org_admin" && user?.role !== "system_admin") {
    return null
  }
  return (
    <Section title="Sales Team Navigation" class="bg-white rounded-lg shadow-sm p-6">
      <HideAccountingFromSalesSetting />
    </Section>
  )
}

function AutoValidationSettingsSection() {
  return (
    <Section title="Auto-Validation Settings" class="bg-white rounded-lg shadow-sm p-6">
      <AutoValidationSettings />
    </Section>
  )
}

function OrgFieldsSettingsSection() {
  return (
    <Section title="Custom Organization Fields" class="bg-white rounded-lg shadow-sm p-6">
      <OrgFieldsSettings />
    </Section>
  )
}

function LogisticsProvidersSettingsSection() {
  return (
    <Section title="Logistics Providers" class="bg-white rounded-lg shadow-sm p-6">
      <LogisticsProvidersSettings />
    </Section>
  )
}

function PromotionImportSection() {
  return (
    <Section title="Promotion Import" class="bg-white rounded-lg shadow-sm p-6">
      <PromotionUpload />
    </Section>
  )
}

function SkuMappingUploadSection() {
  return (
    <Section title="SKU Mapping Upload" class="bg-white rounded-lg shadow-sm p-6">
      <SkuMappingUpload />
    </Section>
  )
}

function ProductCatalogSettingsSection() {
  return (
    <Section title="Product Catalog" class="bg-white rounded-lg shadow-sm p-6">
      <ProductCatalogSettings />
    </Section>
  )
}

function CustomerPricingSettingsSection() {
  return (
    <Section title="Customer Pricing" class="bg-white rounded-lg shadow-sm p-6">
      <CustomerPricingSettings />
    </Section>
  )
}

function EmailSummaryConfigSection() {
  const user = UserState.use()

  // Only show to system admins
  if (!user || user.role !== "system_admin") {
    return null
  }

  return (
    <Section title="Email Summary Configuration" class="bg-white rounded-lg shadow-sm p-6">
      <EmailSummaryConfigComponent orgId={user.org_id!} />
    </Section>
  )
}

function OrganizationFilesSection() {
  return (
    <Section title="Organization Files" class="bg-white rounded-lg shadow-sm p-6">
      <BrandFiles fileSource="settings" />
    </Section>
  )
}
